var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29289 3.29289C2.90237 3.68342 2.90237 4.31658 3.29289 4.70711L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L4.70711 3.29289C4.31658 2.90237 3.68342 2.90237 3.29289 3.29289Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96971 9.40534C1.67676 10.903 1.67676 13.097 2.96971 14.5947L3.39643 15.0889C7.89834 20.3037 16.1017 20.3037 20.6036 15.0889L21.0303 14.5947C22.3232 13.097 22.3232 10.903 21.0303 9.40534L20.6036 8.91105C16.1017 3.69632 7.89834 3.69632 3.39643 8.91105L2.96971 9.40534ZM3.39643 15.0889L4.91032 13.782C8.61448 18.0727 15.3855 18.0727 19.0897 13.782L19.5164 13.2877C20.1612 12.5408 20.1612 11.4592 19.5164 10.7123L19.0897 10.218C15.3855 5.92733 8.61448 5.92733 4.91032 10.218L4.4836 10.7123C3.8388 11.4592 3.8388 12.5408 4.4836 13.2877L4.91032 13.782L3.39643 15.0889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.effeafd1deb9e1e953c961760fd51f23.svg";
export { ForwardRef as ReactComponent };